// import { classes } from "istanbul-lib-coverage";
import React, { useState } from "react";
import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import classes from "./ContentBody.module.css";
import { FaFilter } from "react-icons/fa";
import Edit from "../icons/Edit";
import Eye from "../icons/Eye";
import Trash from "../icons/Trash";

const ContentBody = (props) => {
  const { userList, pageNumber, usersPerPage, pageCount } = props;
  const users = userList.users || [];
  const changePage = ({ selected }) => {
    props.onChangePageNumber(selected);
  };
  const [sortBy, setSortBy] = useState("createDate");
  const [sortType, setSortType] = useState(true);
  const sortClick = (key) => {
    props.onChangeSortClick(key);
    setSortBy(key);
    if (sortType) {
      setSortType(false);
    } else {
      setSortType(true);
    }
    props.onChangeSortType(sortType);
  };
  let count = pageNumber + 1;
  if (count > 1) {
    count = usersPerPage * pageNumber + 1;
  }

  const userStatusChange = async (val, status) => {
    const query = {
      _id: val,
      status: status,
    };

    let text = "You want to change status!";
    let button = "Yes, Change it!";
    if (status === 2) {
      text = "You won't be able to revert this!";
      button = "Yes, delete it!";
    }
    Swal.fire({
      title: "Are you sure?",
      text: text,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: button,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const data = await fetch(
            process.env.REACT_APP_API_URL + "delete-user",
            {
              method: "POST",
              body: JSON.stringify(query),
              headers: {
                "Content-type": "application/json",
              },
            }
          );
          const response = await data.json();
          if (response) {
            props.onStatusRecordChange();
            if (status === 2) {
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
            } else {
              if (status === 1) {
                Swal.fire("Active", "User active successfully", "success");
              } else if (status === 0) {
                Swal.fire(
                  "In-active",
                  "User In-active successfully",
                  "success"
                );
              }
            }
          }
        } catch (e) {
          console.log("error", e);
        }
      }
    });
  };

  const handleSearch = async (e) => {
    props.onSearchChang(e.target.value);
  };

  const setSelectedOption = (e) => {
    props.onPerPageChange(e.target.value);
  };

  const showonMainPageHandler = async (id, status) => {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}change-user-mainpage-feedback`,
      {
        method: "POST",
        body: JSON.stringify({ id: id, status: status }),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (response && response.status === 200) {
      props.onShowUserOnMainPage(!status);
    }
  };

  const displayUsers = users.map((val, i) => {
    return (
      <React.Fragment key={Math.random(1, 9999)}>
        <tr>
          <td>
            {val.name && (
              <React.Fragment>
                {val.name}
                <br />
              </React.Fragment>
            )}
            {val.email}
          </td>
          <td>{val.createDate}</td>
          <td>{val.lastLoginDate}</td>
          <td>
            {val.status === 1 ? (
              <span
                className="badge badge-success badge-lg light"
                onClick={() => {
                  userStatusChange(val._id, 0);
                }}
              >
                Active
              </span>
            ) : (
              <span
                className="badge badge-danger badge-lg light"
                onClick={() => {
                  userStatusChange(val._id, 1);
                }}
              >
                InActive
              </span>
            )}
          </td>
          <td>
            {val.showUserOnMainPage === 1 ? (
              <span
                className="badge badge-success badge-lg light"
                onClick={() => {
                  showonMainPageHandler(val._id, 0);
                }}
              >
                Yes
              </span>
            ) : (
              <span
                className="badge badge-danger badge-lg light"
                onClick={() => {
                  showonMainPageHandler(val._id, 1);
                }}
              >
                No
              </span>
            )}
          </td>
          <td className="text-center">
            <div className="action-buttons d-flex justify-content-end">
              {val.status === 1 && (
                <a
                  className="btn btn-success light mr-2"
                  href={process.env.REACT_APP_CLIENT_URL + val.username}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <Eye />
                </a>
              )}
              <Link
                className="btn btn-secondary light mr-2"
                to={`/admin/edit-user/${val._id}`}
              >
                <Edit />
              </Link>
              <button
                className="btn btn-danger light"
                onClick={() => {
                  userStatusChange(val._id, 2);
                }}
              >
                <Trash />
              </button>
            </div>
          </td>
        </tr>
      </React.Fragment>
    );
  });

  const showingEntries = () => {
    let testTotal = pageNumber + 1;
    let startnumber = (testTotal - 1) * usersPerPage + 1;
    let endnumber =
      testTotal * usersPerPage > testTotal - 1 * usersPerPage
        ? testTotal * 1 * usersPerPage
        : testTotal * usersPerPage;
    if (endnumber > userList.totalUsers) {
      endnumber = userList.totalUsers;
    }
    return (
      "Showing " +
      startnumber +
      " to " +
      endnumber +
      " of " +
      userList.totalUsers +
      " records"
    );
  };

  const statusChangeHandler = (e) => {
    props.onChangeStatus(e);
  };

  return (
    <React.Fragment>
      <div className="content-body">
        <div className="container-fluid">
          <div className="d-flex align-items-center mb-4 flex-wrap">
            <h4 className="fs-20 font-w600  me-auto">Users List</h4>
            <div>
              <Link
                to={"/admin/new-user"}
                className="btn btn-primary me-3 btn-sm"
              >
                <i className="fas fa-plus me-2" />
                Add New User
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="table-responsive">
                <div
                  id="example_wrapper"
                  className="dataTables_wrapper d-flex justify-content-between"
                >
                  <div className="dataTables_length" id="example_length">
                    <label>
                      Show
                      <select
                        name="example_length"
                        aria-controls="example"
                        onChange={setSelectedOption}
                      >
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                      entries
                    </label>
                  </div>
                  <div className="d-flex justify-content-end">
                    <div id="example_filter" className="dataTables_filter mx-4">
                      <input
                        type="search"
                        className="form-control"
                        aria-controls="example"
                        placeholder="Search..."
                        onKeyDown={(e) => e.key === "Enter" && handleSearch(e)}
                      />
                    </div>
                    {/* <div>
                      <button
                        id="btnGroupDrop1"
                        type="button"
                        className="btn btn-primary dropdown-toggle"
                        data-bs-toggle="dropdown"
                      >
                        <FaFilter />
                      </button>
                      <div
                        className="dropdown-menu"
                        style={{ left: "1320px", top: "15px" }}
                      >
                        <a className="dropdown-item">Active</a>
                        <a className="dropdown-item">InActive</a>
                      </div>
                    </div> */}
                    <div
                      id="userListDropdownBtn"
                      className="btn-group"
                      role="group"
                    >
                      <button
                        type="button"
                        className="btn btn-primary dropdown-toggle"
                        data-bs-toggle="dropdown"
                      >
                        <FaFilter />
                      </button>
                      <div className="dropdown-menu">
                        <button
                          className={`dropdown-item ${
                            props.statusChange === 1 && "active"
                          }`}
                          onClick={() => statusChangeHandler(1)}
                        >
                          Active
                        </button>
                        <button
                          className={`dropdown-item ${
                            props.statusChange === 0 && "active"
                          }`}
                          onClick={() => statusChangeHandler(0)}
                        >
                          InActive
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <table
                  className="table display mb-4 dataTablesCard job-table table-responsive-xl card-table"
                  id={classes["users-list-main"]}
                >
                  <thead>
                    <tr>
                      <th
                        onClick={() => {
                          sortClick("name");
                        }}
                      >
                        User Details
                        {sortBy === "name" && sortType === true ? (
                          <IoIosArrowDropdown />
                        ) : null}
                        {sortBy === "name" && sortType === false ? (
                          <IoIosArrowDropup />
                        ) : null}
                      </th>
                      {/* <th
                        onClick={() => {
                          sortClick("email");
                        }}
                      >
                        Email
                        {sortBy === "email" && sortType === true ? (
                          <IoIosArrowDropdown />
                        ) : null}
                        {sortBy === "email" && sortType === false ? (
                          <IoIosArrowDropup />
                        ) : null}
                      </th> */}
                      <th
                        onClick={() => {
                          sortClick("createDate");
                        }}
                      >
                        Joined Date
                        {sortBy === "createDate" && sortType === true ? (
                          <IoIosArrowDropdown />
                        ) : null}
                        {sortBy === "createDate" && sortType === false ? (
                          <IoIosArrowDropup />
                        ) : null}
                      </th>
                      <th
                        onClick={() => {
                          sortClick("lastLogin");
                        }}
                      >
                        Last Login
                        {sortBy === "lastLogin" && sortType === true ? (
                          <IoIosArrowDropdown />
                        ) : null}
                        {sortBy === "lastLogin" && sortType === false ? (
                          <IoIosArrowDropup />
                        ) : null}
                      </th>
                      <th
                        onClick={() => {
                          sortClick("status");
                        }}
                      >
                        Status
                        {sortBy === "status" && sortType === true ? (
                          <IoIosArrowDropdown />
                        ) : null}
                        {sortBy === "status" && sortType === false ? (
                          <IoIosArrowDropup />
                        ) : null}
                      </th>
                      <th>
                        Show On <br /> Main Page
                      </th>
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.length > 0 && displayUsers}
                    {users.length === 0 && (
                      <tr>
                        <td colSpan="6">
                          <div className="text-center">
                            <h4>Sorry!</h4>
                            <h5>No users Found.</h5>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col-xl-12">
              <div className="d-flex align-items-center justify-content-between flex-wrap">
                <div className="sm-mb-0 mb-3">
                  <h5>{showingEntries()}</h5>
                </div>
                <ReactPaginate
                  previousLabel="Previous"
                  nextLabel="Next"
                  pageCount={pageCount}
                  onPageChange={changePage}
                  containerClassName="pagination pagination-circle"
                  previousClassName="page-item page-indicator"
                  previousLinkClassName="page-link"
                  nextClassName="page-item page-indicator"
                  nextLinkClassName="page-link"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  disabledClassName="disabled"
                  activeClassName="active"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default ContentBody;
